import { render, staticRenderFns } from "./AftTooltip.vue?vue&type=template&id=54bc3b5f&scoped=true"
import script from "./AftTooltip.vue?vue&type=script&lang=js"
export * from "./AftTooltip.vue?vue&type=script&lang=js"
import style0 from "./AftTooltip.vue?vue&type=style&index=0&id=54bc3b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc3b5f",
  null
  
)

export default component.exports